/**
 * 单个车辆转移
 */
import {useState, forwardRef, useImperativeHandle, useRef, useEffect} from "react";
import {WWInput,AuthButton} from "@/globalComponents/index";
import { Modal} from "antd";
import "@/assets/styles/modal.scss"
function AddEmails(props, ref){
    const [visible,setVisible] = useState(false);
    const [emails,setEmails] = useState([""])
    //暴露给父组件的方法
    useImperativeHandle(ref, () => ({
        setVisible:()=>{
           setVisible(true)
        },
        hideModal:()=>{
            hideModal();
        }
    }));
    const hideModal = ()=>{
        setVisible(false);
        setEmails([""])
    }
    const setValue = (value,index)=>{
        let temp = Array.from(emails,(x,curIndex)=>{
            let temp_x = x;
            if(curIndex === index){
                temp_x=value;
            }
            return temp_x;
        })
        setEmails(temp);
    }
    //新增或者删除某一个邮箱
    const addDelItem = (index,type)=>{
        let temp_arr = Array.from(emails);
        if(type === "del"){
            temp_arr.splice(index,1);
        }else{
            temp_arr.push("");
        }

        setEmails(temp_arr);
    }

    const emailItem = ()=>{
        return emails.map((item,index) =>{
            return <div className="modal_item ">
            <label className={"font"}>{Strings.emailAddr || "邮箱地址"}{index+1}</label>
             <WWInput className="w240 mgl30" value={item} onChange={(e)=>{setValue(e,index)}}></WWInput>
             {emails.length < 5 ?<i className="icon blue iconfont icon-tianjia mgl15" onClick={()=>{addDelItem()}}></i>:null}
             {emails.length === 1 ?null:<i className="icon red iconfont icon-shanchu mgl5" onClick={()=>addDelItem(index,"del")}></i>}
         </div>
        })
    }

    return (
        <Modal {...props} ref={ref} transitionName="" maskTransitionName="" visible={visible}
               className={"default_modal addEmail"}
               maskClosable={false} title={Strings.addEmailsTitle || "添加邮箱"}
               width={510}
               onCancel={() => {
                   hideModal();
               }} footer={null}>
            {emailItem()}
            <div className="modal_item modal_btns">
                <AuthButton authKey={true}  onClick={()=>{  hideModal()}}>{Strings.cancel || "取消" }</AuthButton>
                <AuthButton authKey={true} className="mgl10" type="primary" onClick={()=>{props.setEmailsData(emails)}}>{Strings.sure || "确定"}</AuthButton>
            </div>
        </Modal>
    )
}
export default forwardRef(AddEmails)